<template>
  <div class="containerFootGuide">
    <ol class="listFootGuide">
      <li>{{ i18n['list']['1'] }}</li>
      <li>{{ i18n['list']['2'] }}</li>
      <li>{{ i18n['list']['3'] }}</li>
    </ol>
    <div class="imageFootGuide">
      <img src="https://storage.googleapis.com/cleed-datacenter-europe/shoes/Mesure-Schema-foot.svg" :alt="i18n['altImage']" class="piedFootGuide">
    </div>
  </div>
</template>

<script>
export default {
  name: "FootGuide",
  components: {},
  props: {
    i18n: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.containerFootGuide {
  gap: 20px !important;
  align-items: center !important;
}

.listFootGuide {
  margin: 0 !important;
  padding: 0 0 0 1.5em !important;
  font-size: 16px !important;
}

.imageFootGuide {
  text-align: center !important;
  justify-self: center !important;
  margin-top: 20px !important;
  display:block !important;
}

.piedFootGuide {
  max-width: 75% !important;
}
</style>
